/**
 * State Management Service - Simple functions for Redux state updates
 */

import type { Dispatch } from '@reduxjs/toolkit';

import {
  addCompletedStep,
  addVisitedStep,
  setActiveStep,
  setEndpointKey,
} from '../data-store/copilotSlice';

export const completeStep = (dispatch: Dispatch, stepName: string): void => {
  dispatch(addCompletedStep(stepName));
};

export const visitStep = (dispatch: Dispatch, stepName: string): void => {
  dispatch(addVisitedStep(stepName));
};

export const setActive = (dispatch: Dispatch, stepName: string): void => {
  dispatch(setActiveStep(stepName));
};

export const setEndpoint = (dispatch: Dispatch, key: number): void => {
  dispatch(setEndpointKey(key));
};

export const completeAndMoveToStep = (
  dispatch: Dispatch,
  fromStep: string,
  toStep: string
): void => {
  completeStep(dispatch, fromStep);
  visitStep(dispatch, toStep);
  setActive(dispatch, toStep);
};
